"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = Dropdown;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const dropdown_item_1 = require("./partials/dropdown-item");
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon/");
const dropdown_module_scss_1 = __importDefault(require("./dropdown.module.scss"));
const TIMEOUT_TIME = 500;
function Dropdown({ ariaLabel, canScroll, children, defaultText, disabled, disabledItems, iconAlt = 'view option list', iconDescription = 'dropdownArrow', iconName = 'expand', id, isOpen, itemsData, onChange = () => { }, selectedText = '', selectedValue = '', selectProps, className, listClassName, itemClassName, textClassName, wrapperClassName, toggleClassName, iconClassName, ...other }) {
    const [isDropdownOpen, setIsDropdownOpen] = (0, react_1.useState)(isOpen);
    const [selectedItem, setSelectedItem] = (0, react_1.useState)({ value: selectedValue || '', text: selectedText || defaultText });
    const [textKeysPressed, setTextKeysPressed] = (0, react_1.useState)('');
    const [dropdownItemToFocus, setDropdownItemToFocus] = (0, react_1.useState)();
    const [initialDropdownItemIndex, setInitialDropdownItemIndex] = (0, react_1.useState)(0);
    const [clearTextKeysPressed, setClearTextKeysPressed] = (0, react_1.useState)();
    const dropdownContainerRef = (0, react_1.useRef)();
    const dropdownListRef = (0, react_1.useRef)();
    const dropdownToggleRef = (0, react_1.useRef)();
    const allItems = itemsData || children
        ? itemsData || (children && children.length
            && children.filter(child => child && child)
                .map(({ text, value, children: customItem }) => ({ text, value, customItem })))
        : [];
    (0, react_1.useEffect)(() => {
        setSelectedItem(getMatchingChild());
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (selectedText || selectedValue) {
            const matchingChild = getMatchingChild(selectedValue, selectedText);
            if (matchingChild) {
                setSelectedItem(matchingChild);
            }
        }
    }, [selectedText, selectedValue]);
    (0, react_1.useEffect)(() => {
        if (dropdownItemToFocus) {
            dropdownItemToFocus.focus();
        }
    }, [dropdownItemToFocus]);
    (0, react_1.useEffect)(() => {
        if (isDropdownOpen) {
            document.addEventListener('click', handleOutsideClick);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
        }
    }, [isDropdownOpen]);
    (0, react_1.useEffect)(() => {
        if (textKeysPressed) {
            clearTextKeysPressedAfterDelay();
            focusItemFromTextKeysPressed();
        }
    }, [textKeysPressed]);
    // TODO: update check for matching child and setting selected values
    // to work with an array if we want to allow for multiple selections
    const getMatchingChild = (newSelectedValue = selectedValue, newSelectedText = '') => (allItems.find((item, index) => {
        if (item && (item.text === newSelectedText || item.value === newSelectedValue)) {
            setInitialDropdownItemIndex(index);
            return item;
        }
    }) || { value: '', text: defaultText });
    const toggle = (e) => {
        if (disabled) {
            return;
        }
        // Open on click, enter, or space
        const isKeyPressTarget = e.target === e.currentTarget;
        const isValidKeyPress = [' ', 'Enter'].indexOf(e.key) !== -1;
        if ((isKeyPressTarget && isValidKeyPress) || e.type === 'click') {
            setIsDropdownOpen(!isDropdownOpen);
        }
    };
    const handleSelectionClick = (info) => {
        onChange(info);
        let selectedItemIndex = allItems.findIndex(({ value }) => value === info.value);
        setDropdownItemToFocus(dropdownListRef.current.children[selectedItemIndex]);
        setSelectedItem(allItems[selectedItemIndex]);
        setTextKeysPressed('');
        setIsDropdownOpen(!isDropdownOpen);
    };
    // TODO: add exception handling if 'text' and 'value' are not provided in data
    const buildItemsFromData = (itemData) => itemData.map((item, i) => ((0, jsx_runtime_1.jsx)(dropdown_item_1.DropdownItem, { className: itemClassName, disabled: item.isItemDisabled || (disabledItems && disabledItems.includes(item.value)), id: i === 0 ? 'default' : null, onSelect: handleSelectionClick, selected: item.value === selectedItem.value, text: item.text, value: item.value, children: item.customItem }, `item${i}`)));
    const buildSelectOptionsFromData = (itemsData) => (itemsData.map(({ text, value }, i) => ((0, jsx_runtime_1.jsx)("option", { label: text, value: value, children: text }, `dropdown-select-${i}`))));
    const buildItemsFromChildren = () => react_1.default.Children.toArray(children)
        .filter(Boolean)
        .map((child, i) => react_1.default.cloneElement(child, {
        onSelect: (...args) => {
            child.props.onClick && child.props.onClick(...args);
            handleSelectionClick(...args);
        },
        id: i === 0 ? 'default' : null,
        selected: child.props.value === selectedItem.value,
    }));
    const buildSelectOptionsFromChildren = () => {
        const items = react_1.default.Children.toArray(children);
        return items.filter(Boolean).map((item, i) => ((0, jsx_runtime_1.jsx)("option", { label: item.props.text, value: item.props.value, children: item.props.text }, `dropdown-select-${i}`)));
    };
    const handleOutsideClick = (event) => {
        const isClickOutsideContainer = dropdownContainerRef.current &&
            !dropdownContainerRef.current.contains(event.target);
        isClickOutsideContainer && setIsDropdownOpen(false);
    };
    const handleDropdownContainerKeyDown = (event) => {
        const keyPressed = event.key;
        switch (keyPressed) {
            case 'Escape':
                dropdownToggleRef.current.focus();
                setIsDropdownOpen(false);
                break;
            case 'Tab':
                event.currentTarget.blur();
                setIsDropdownOpen(false);
                break;
            case 'ArrowDown':
            case 'ArrowUp':
                event.preventDefault();
                !isDropdownOpen && setIsDropdownOpen(true);
                const dropdownListChildren = [...dropdownListRef.current.children];
                const focusedDropdownItemIndex = dropdownItemToFocus ? dropdownListChildren.indexOf(dropdownItemToFocus) : initialDropdownItemIndex;
                if (keyPressed === 'ArrowDown') {
                    if (focusedDropdownItemIndex !== (dropdownListChildren.length - 1)) {
                        setDropdownItemToFocus(dropdownListChildren[focusedDropdownItemIndex + 1]);
                    }
                }
                else {
                    if (focusedDropdownItemIndex !== 0) {
                        setDropdownItemToFocus(dropdownListChildren[focusedDropdownItemIndex - 1]);
                    }
                }
                break;
            default:
                keyPressed.length === 1 && setTextKeysPressed(textKeysPressed + keyPressed);
        }
    };
    const focusItemFromTextKeysPressed = () => {
        const dropdownListItems = [...dropdownListRef.current.children];
        const searchedDropdownListItem = dropdownListItems.find(dropdownListItem => {
            const dropdownListText = dropdownListItem.innerText || dropdownListItem.textContent;
            return dropdownListText.toLowerCase().startsWith(textKeysPressed.toLowerCase());
        });
        if (searchedDropdownListItem) {
            if (!isDropdownOpen) {
                setIsDropdownOpen(true);
            }
            setDropdownItemToFocus(searchedDropdownListItem);
        }
    };
    const clearTextKeysPressedAfterDelay = () => {
        if (clearTextKeysPressed) {
            clearTimeout(clearTextKeysPressed);
            setClearTextKeysPressed(null);
        }
        const newTimeOut = setTimeout(() => {
            setTextKeysPressed('');
            setClearTextKeysPressed(null);
        }, TIMEOUT_TIME);
        setClearTextKeysPressed(newTimeOut);
    };
    const classes = (0, classnames_1.default)(dropdown_module_scss_1.default.dropdown, { [dropdown_module_scss_1.default['dropdown--is-disabled']]: disabled }, { [dropdown_module_scss_1.default['dropdown--is-open']]: isDropdownOpen }, { 'dropdown--is-open': isDropdownOpen }, // non css module class for custom styling based on state
    className);
    const wrapperClasses = (0, classnames_1.default)(dropdown_module_scss_1.default.dropdownWrapper, wrapperClassName);
    const listClasses = (0, classnames_1.default)(dropdown_module_scss_1.default.list, { [dropdown_module_scss_1.default['list--is-open']]: isDropdownOpen }, { 'list--is-open': isDropdownOpen }, // non css module class for custom styling based on state
    { [dropdown_module_scss_1.default['list--has-scroll']]: canScroll }, listClassName);
    const iconClasses = (0, classnames_1.default)(dropdown_module_scss_1.default.icon, { [dropdown_module_scss_1.default['icon--is-open']]: isDropdownOpen }, iconClassName);
    const dropdownSelectProps = {
        ...selectProps,
        className: dropdown_module_scss_1.default.select,
        disabled: disabled,
        tabIndex: -1,
        value: selectedItem.value,
        title: defaultText
    };
    const listItems = itemsData ? buildItemsFromData(itemsData) : buildItemsFromChildren();
    const selectItems = itemsData ? buildSelectOptionsFromData(itemsData) : buildSelectOptionsFromChildren();
    return ((0, jsx_runtime_1.jsxs)("div", { className: wrapperClasses, onKeyDownCapture: handleDropdownContainerKeyDown, ref: dropdownContainerRef, children: [(0, jsx_runtime_1.jsxs)("select", { onChange: (event) => {
                    const selectedItemIndex = event.target.selectedIndex;
                    const selectedValue = event.target.value;
                    const matchingChild = getMatchingChild(selectedValue);
                    const selectedText = matchingChild ? matchingChild.text : defaultText;
                    onChange(matchingChild);
                    setSelectedItem(matchingChild);
                    setDropdownItemToFocus(dropdownListRef.current.children[selectedItemIndex]);
                }, ...dropdownSelectProps, children: [(0, jsx_runtime_1.jsx)("option", { value: '', label: defaultText, children: defaultText }), selectItems] }), (0, jsx_runtime_1.jsxs)("div", { className: classes, ...other, children: [(0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(dropdown_module_scss_1.default.toggle, toggleClassName), role: "combobox", tabIndex: 0, "aria-autocomplete": "none", "aria-owns": id, "aria-expanded": isDropdownOpen, "aria-labelledby": ariaLabel, "aria-required": true, "aria-activedescendant": "default", value: selectedItem.value, onClick: toggle, onKeyUp: toggle, ref: dropdownToggleRef, "data-selector": `${(0, lodash_1.kebabCase)(id)}-toggle`, children: [(0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(dropdown_module_scss_1.default.text, textClassName), children: selectedItem.customItem || selectedItem.text }), (0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { alt: iconAlt || 'Display dropdown options', className: iconClasses, description: iconDescription || 'Display dropdown options', name: iconName, titleId: "dropdownArrow" })] }), (0, jsx_runtime_1.jsx)("ul", { role: "listbox", className: listClasses, id: `${id}_select`, ref: dropdownListRef, "data-selector": `${(0, lodash_1.kebabCase)(id)}-list`, children: listItems })] })] }));
}
Dropdown.propTypes = {
    ariaLabel: prop_types_1.default.string,
    canScroll: prop_types_1.default.bool,
    children: prop_types_1.default.oneOfType([
        prop_types_1.default.arrayOf(prop_types_1.default.node),
        prop_types_1.default.node
    ]),
    className: prop_types_1.default.string,
    listClassName: prop_types_1.default.string,
    itemClassName: prop_types_1.default.string,
    textClassName: prop_types_1.default.string,
    toggleClassName: prop_types_1.default.string,
    wrapperClassName: prop_types_1.default.string,
    defaultText: prop_types_1.default.string.isRequired,
    disabled: prop_types_1.default.bool,
    iconAlt: prop_types_1.default.string.isRequired,
    iconClassName: prop_types_1.default.string,
    iconDescription: prop_types_1.default.string,
    iconName: prop_types_1.default.string,
    id: prop_types_1.default.string.isRequired,
    isOpen: prop_types_1.default.bool,
    itemsData: prop_types_1.default.arrayOf(prop_types_1.default.shape({})),
    onChange: prop_types_1.default.func,
    selectedText: prop_types_1.default.string,
    selectedValue: prop_types_1.default.string,
    selectProps: prop_types_1.default.object
};
//# sourceMappingURL=dropdown.js.map